/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RunProgramDataParser = /* #__PURE__ */ parsers.object([
    ['program', codecString],
]);
export class RunProgramData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RunProgramDataParser.decode(input).map(res => new RunProgramData(res));
    }
    static unsafeDecode(input) {
        return RunProgramData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RunProgramDataParser.encode(data);
    }
    static schema() {
        return RunProgramDataParser.schema();
    }
}
